import * as React from 'react';
import LoadingBlock from './LoadingBlock';

export default function PageLoader({ label }) {
  return <LoadingBlock label={label} className="min-h-[60vh]" />;
}
